import { get } from 'lodash';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import Footer from './Footer';
import DEFAULT_LOGO from '../../assets/svg/Jitsu-color.svg';

function FooterContainer(props) {
  const { store, styles } = props;
  const { deliveryStore } = store;
  const { delivery, profile } = deliveryStore;

  const client = get(props, 'client') || get(delivery, 'client');
  const settings = get(props, 'settings') || get(deliveryStore, 'settings');

  const emailSubject = settings?.tracking_support_email_subject;
  const logo = settings?.use_client_logo === 'true' && delivery?.client?.logo_url ? delivery.client.logo_url : DEFAULT_LOGO;

  const clientConfig = {
    clientLogo: logo,
    clientName: client?.company,
    clientPhone: settings?.client_support_phone_number ? settings.client_support_phone_number : '',
    clientCustomText: settings?.client_support_custom_text ? settings.client_support_custom_text : '',
    clientEmail: client?.support_email ? client?.support_email : null,
    ...profile?.props,
  };

  const clientLogo = clientConfig.clientLogo;
  const clientTitle = clientConfig.clientName
    ? `<span style="font-weight: 600">Got package questions?</span> <br/> <span>please contact ${clientConfig.clientName}</span> \
  <br/> <span>${clientConfig.clientCustomText}</span>`
    : null;
  const clientPhone = clientConfig?.clientPhone ? `tel:${clientConfig.clientPhone}` : null;
  const clientEmail = clientConfig?.clientEmail ? `mailto:${clientConfig.clientEmail}?subject=${emailSubject}` : null;

  const FAQ_URL = import.meta.env.REACT_APP_FAQ_URL;

  const axlehireConfig = {
    showAxlehireSupportPhone: settings?.tracking_show_axlehire_support_phone,
    showAxlehireSupportEmail: settings?.tracking_show_axlehire_support_email,
    axlehireSupportPhone: settings?.axlehire_support_phone_number,
    axlehireSupportEmail: settings?.axlehire_support_phone_email,
    ...profile?.props,
  };

  const showAxlehireSupport = axlehireConfig.showAxlehireSupportPhone === 'true' || axlehireConfig.showAxlehireSupportEmail === 'true';
  const axlehireTitle = `<span style="font-weight: 600">Got delivery questions?</span> <br/> <span>visit our FAQs at <a href=${FAQ_URL} target="_blank">${FAQ_URL}</a><br/>or contact Jitsu</span>`;
  const axlehirePhone =
    axlehireConfig.showAxlehireSupportPhone === 'true' && axlehireConfig.axlehireSupportPhone ? `tel:${axlehireConfig.axlehireSupportPhone}` : null;
  const axlehireEmail =
    axlehireConfig.showAxlehireSupportEmail === 'true' && axlehireConfig.axlehireSupportEmail
      ? `mailto:${axlehireConfig.axlehireSupportEmail}?subject=${emailSubject}`
      : null;

  let dataProps = { clientLogo, clientTitle, clientEmail, clientPhone, showAxlehireSupport, axlehireTitle, axlehireEmail, axlehirePhone };
  if (typeof profile?.props === 'object') dataProps = { ...dataProps, ...profile.props };

  return <Footer {...dataProps} styles={styles} />;
}

FooterContainer.propTypes = {
  client: PropTypes.shape({
    company: PropTypes.string,
    support_email: PropTypes.string,
  }),
  settings: PropTypes.shape({
    tracking_support_email_subject: PropTypes.string,
    client_support_phone_number: PropTypes.string,
    tracking_show_axlehire_support_phone: PropTypes.string,
    tracking_show_axlehire_support_email: PropTypes.string,
    client_support_custom_text: PropTypes.string,
    axlehire_support_phone_number: PropTypes.string,
    axlehire_support_phone_email: PropTypes.string,
  }),
  profile: PropTypes.shape({
    clientLogo: PropTypes.string,
    clientName: PropTypes.string,
    clientEmail: PropTypes.string,
    clientPhone: PropTypes.string,
    showAxlehireSupportPhone: PropTypes.string,
    showAxlehireSupportEmail: PropTypes.string,
    axlehireSupportPhone: PropTypes.string,
    axlehireSupportEmail: PropTypes.string,
  }),
};

export default compose(inject('store'), observer)(FooterContainer);
